import React from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-right" aria-hidden="true"/>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-left" aria-hidden="true"/>
        </div>
    );
}

class TrendsNav extends React.Component {
    state = {
        isClient: false
    }

    componentDidMount() {
        this.setState({isClient: true});
    }

    render() {
        const { items, title, sponsor, cleanURL } = this.props;

        let slidesToShow = items.length > 5 ? 5.25 : items.length;
        let currentSlide = items.findIndex(item => item.isCurrent);
        let initialSlide = 0;
        let previewToken  = "";

        if(this.state.isClient){
            let smSlidesToShow = 1.25;
            let mdSlidesToShow = 3.25;
            let lgSlidesToShow = 3.25;
    
            if(window.innerWidth <= 568) {
                slidesToShow = (items.length - 1) > Math.floor(smSlidesToShow) ? smSlidesToShow : items.length;
            } else if(window.innerWidth <= 800) {
                slidesToShow = (items.length - 1) > Math.floor(mdSlidesToShow) ? mdSlidesToShow : items.length;
            } else if(window.innerWidth <= 1200) {
                slidesToShow = (items.length - 1) > Math.floor(lgSlidesToShow) ? lgSlidesToShow : items.length;
            }

            const url = document.location.search;
            const keyword = "?token=";
            if(url.indexOf(keyword) > -1){
                previewToken = url.split(keyword).pop();
            }
        }

        if(currentSlide >= Math.floor(slidesToShow)) {
            initialSlide = currentSlide - Math.floor(slidesToShow) + 1;
        }

        const sliderConfig = {
            dots: false,
            lazyLoad: true,
            infinite: false,
            centerMode: false,
            initialSlide: initialSlide,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            swipeToSlide: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };

        return (
            <div className="NavBackground">
                <div className="TrendsNav">
                    {sponsor.activeSponsor &&
                        <div className="TrendsSponsor">
                            <p>Series Sponsor</p>
                            <picture>
                                {
                                    sponsor.sponsorLogo.sourceTagData.map((data, index) => {
                                        return (
                                            <source key={index} media={data.media} srcSet={data.srcset} type={data.type} />
                                        );
                                    })
                                }
                                <img className={sponsor.sponsorLogo.imageTagData.class} src={sponsor.sponsorLogo.imageTagData.src} alt={sponsor.sponsorLogo.imageTagData.alt} title={sponsor.sponsorLogo.imageTagData.title}></img>
                            </picture>
                        </div>
                    }
                    <div className="seriesTitle">
                        {items.length}-part series
                        <br/>
                        <span>
                            <a href={cleanURL} dangerouslySetInnerHTML={{ __html: title }}>
                            </a>
                        </span>
                    </div>
                    <nav className="menu-wrapper">
                        <div className="menu">
                            <Slider {...sliderConfig} ref={slider => this.slider = slider && slider["innerSlider"]}>
                                {
                                    items.map((item, index) => {
                                        if(previewToken) {
                                            item.url = item.url + `?token=${previewToken}`;
                                        }
                                        return (
                                            <div key={index} className={`ideaNavItem item ${item.isCurrent ? "active" : ""} ${item.isPublished ? "published" : "unpublished"} `}>
                                                <a href={item.isPublished || previewToken ? item.url : null}>
                                                    <p className="max-3-lines" dangerouslySetInnerHTML={{ __html: item.label }}></p>
                                                </a>
                                            </div>
                                        );
                                    })
                                }
                            </Slider>
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}

export default TrendsNav;
